import { Clickable, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const OptionItem = ({ option, selectedOption, setSelectedOption, index, onClick }) => {
  const isSelected = index === selectedOption,
    { t } = useTranslation();

  return (
    <Clickable onClick={onClick || (() => setSelectedOption(index))}>
      <Row
        pad="8px 23px"
        bg={isSelected ? theme.SECONDARY_20 : theme.GREY_20}
        hasRadius="32px"
        hasBorder={`1px solid ${isSelected ? theme.SECONDARY : 'transparent'}`}
      >
        <Text b1 med>
          {t(option)}
        </Text>
      </Row>
    </Clickable>
  );
};

export default OptionItem;
